import { UserManager, type UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts'

function buildOidcSettings(): UserManagerSettings {
  const baseUrl = import.meta.env.VITE_API_BASE_URL
  const realm = import.meta.env.VITE_OIDC_REALM
  const clientId = import.meta.env.VITE_OIDC_CLIENT_ID
  const authority = `${baseUrl}/login/realms/${realm}`

  return {
    authority,
    client_id: clientId,
    redirect_uri: `${window.location.origin}${import.meta.env.BASE_URL}callback`,
    post_logout_redirect_uri: `${window.location.origin}${import.meta.env.BASE_URL}`,
    response_type: 'code',
    scope: 'openid',
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
    metadataUrl: `${authority}/.well-known/openid-configuration`,
  }
}

let _userManager: UserManager | null = null

export function getUserManager(): UserManager {
  if (!_userManager) {
    _userManager = new UserManager(buildOidcSettings())
  }
  return _userManager
}

export async function login(): Promise<void> {
  const mgr = getUserManager()
  await mgr.signinRedirect()
}

export async function handleCallback(): Promise<void> {
  const mgr = getUserManager()
  await mgr.signinRedirectCallback()
}

export async function logout(): Promise<void> {
  const mgr = getUserManager()
  await mgr.signoutRedirect()
}

export async function getAccessToken(): Promise<string | null> {
  const mgr = getUserManager()
  const user = await mgr.getUser()
  return user?.access_token ?? null
}
